import { jsx as r } from "react/jsx-runtime";
import { cn as e } from "./designsystem-ui-react47.js";
function l({ position: t = "top-left", className: o, children: s }) {
  return /* @__PURE__ */ r("div", { className: e("tw-absolute tw-z-10", {
    "top-left": "tw-top-2 tw-left-2",
    "top-right": "tw-top-2 tw-right-2",
    "bottom-left": "tw-bottom-2 tw-left-2",
    "bottom-right": "tw-bottom-2 tw-right-2"
  }[t], o), children: s });
}
export {
  l as CardBadge
};
